module.exports = __webpack_public_path__ + "img/hang_up.97a1bf42.svg";